import React, {useRef} from 'react';
import { EChart as ReactECharts } from '../EChart';
import * as echarts from 'echarts/core';
import ReactEChartsCore from '../EChart';
import { Card } from 'react-bootstrap';
import { LineChart } from 'echarts/charts';
import {
  TitleComponent,
  TooltipComponent,
  ToolboxComponent,
  VisualMapComponent,
  GridComponent
} from 'echarts/components';
import { CanvasRenderer } from 'echarts/renderers';

echarts.use([
    TitleComponent,
    TooltipComponent,
    ToolboxComponent,
    VisualMapComponent,
    GridComponent,
    LineChart,
    CanvasRenderer
  ]);

const MachineRpmChart = () => {

    const chartRef = useRef(null)

    const option = {
        title: {
          text: 'Distribution of Electricity',
          subtext: 'Fake Data'
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'cross'
          }
        },
        toolbox: {
          show: true,
          feature: {
            saveAsImage: {}
          }
        },
        xAxis: {
          type: 'category',
          boundaryGap: false,
          data: [
            '00:00', '01:15', '02:30', '03:45', '05:00', '06:15', '07:30',
            '08:45', '10:00', '11:15', '12:30', '13:45', '15:00', '16:15',
            '17:30', '18:45', '20:00', '21:15', '22:30', '23:45'
          ]
        },
        yAxis: {
          type: 'value',
          axisLabel: {
            formatter: '{value} rmp'
          },
          axisPointer: {
            snap: true
          }
        },
        series: [
          {
            name: 'Motor Rpm E75',
            type: 'line',
            smooth: true,
            data: [
              35,35,50,33,32,38,40,41,42,39,34,30,40,35,35,50,33,32,38,40,41,42,39,34,30,40,35,35,50,33,32,38,40,41,42,39,34,30,40
            ],

          },
          {
            name: 'Electricity E40',
            type: 'line',
            smooth: true,
            data: [
                15,25,20,23,22,18,10,21,22,12,14,10,10,25,15,20,23,12
            ],
          }
        ]
      };


  return (
    <Card className="h-100">
    <Card.Body className='d-flex justify-content-center'>
        <ReactEChartsCore
          ref={chartRef}
          echarts={echarts}
          option={option}
          style={{ height: '316px', width: '130%' }}
        />
    </Card.Body>
</Card>
  )
}

export default MachineRpmChart